"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.M365HelpLink = exports.advancedDASettingUrl = exports.officeBaseUrl = exports.outlookBaseUrl = exports.outlookCopilotAppId = exports.Hub = void 0;
var Hub;
(function (Hub) {
    Hub["teams"] = "Teams";
    Hub["outlook"] = "Outlook";
    Hub["office"] = "the Microsoft 365 app";
    Hub["copilot"] = "Copilot";
})(Hub || (exports.Hub = Hub = {}));
exports.outlookCopilotAppId = "d870f6cd-4aa5-4d42-9626-ab690c041429";
exports.outlookBaseUrl = "https://outlook.office.com";
exports.officeBaseUrl = "https://www.office.com";
exports.advancedDASettingUrl = "https://aka.ms/atk-da-share";
exports.M365HelpLink = "https://aka.ms/teamsfx-actions/teamsapp-extendToM365";
//# sourceMappingURL=constants.js.map